import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LexacquireTopnav from "./lexacquiretopnav";
import "./Request.css";

export default function Request() {
  const navigate = useNavigate();

  // Form state
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [industry, setIndustry] = useState("");
  const [category, setCategory] = useState("");
  const [budget, setBudget] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  // Save to localStorage utility
  const saveRequest = (request) => {
    try {
      const existing = localStorage.getItem("agentRequests");
      let arr = [];
      if (existing) {
        arr = JSON.parse(existing);
        if (!Array.isArray(arr)) arr = [];
      }
      arr.push(request);
      localStorage.setItem("agentRequests", JSON.stringify(arr));
    } catch (e) {
      console.error("Error saving request:", e);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);

    // Basic validation
    if (!title.trim() || !description.trim() || !contactEmail.trim()) {
      setError("Please fill in Title, Description, and Contact Email.");
      return;
    }

    setSubmitting(true);

    const newRequest = {
      id: `request-${Date.now()}`,
      title: title.trim(),
      description: description.trim(),
      industry: industry.trim(),
      category: category.trim(),
      budget: budget.trim(),
      contactEmail: contactEmail.trim(),
      createdAt: new Date().toISOString(),
    };

    saveRequest(newRequest);

    // Simulate a small delay, then navigate back (e.g., to landscape or a “Thank you” page)
    setTimeout(() => {
      setSubmitting(false);
      navigate("/lexacquire/landscape");
    }, 500);
  };

  return (
    <div className="request-page">
      {/* ─── TOP NAV ─── */}
      <LexacquireTopnav />

      <div className="request-container">
        <h2>Request an AI Agent</h2>
        <p className="request-subtitle">
          Tell us what kind of AI agent you need, and our team will try to match you with the right developer or existing solution.
        </p>

        {error && <p className="request-error">{error}</p>}

        <form className="request-form" onSubmit={handleSubmit}>
          {/* Request Title */}
          <label className="form-label">
            Request Title<span className="required">*</span>
          </label>
          <input
            type="text"
            className="form-input"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="E.g., 'Customer Support Chatbot for E-commerce'"
            required
          />

          {/* Detailed Description */}
          <label className="form-label">
            Detailed Description<span className="required">*</span>
          </label>
          <textarea
            className="form-textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            placeholder="Describe the functionality, integrations, or any must-have features."
            required
          />

          {/* Industry */}
          <label className="form-label">Industry</label>
          <input
            type="text"
            className="form-input"
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
            placeholder="e.g., Healthcare, Finance, Retail…"
          />

          {/* Category */}
          <label className="form-label">Category</label>
          <input
            type="text"
            className="form-input"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            placeholder="e.g., Chatbot, Recommendation System…"
          />

          {/* Budget */}
          <label className="form-label">Estimated Budget</label>
          <input
            type="text"
            className="form-input"
            value={budget}
            onChange={(e) => setBudget(e.target.value)}
            placeholder="e.g., '$5k-$10k', 'TBD'…"
          />

          {/* Contact Email */}
          <label className="form-label">
            Contact Email<span className="required">*</span>
          </label>
          <input
            type="email"
            className="form-input"
            value={contactEmail}
            onChange={(e) => setContactEmail(e.target.value)}
            placeholder="yourname@example.com"
            required
          />

          <button
            type="submit"
            className="request-btn"
            disabled={submitting}
          >
            {submitting ? "Submitting…" : "Submit Request"}
          </button>
        </form>
      </div>
    </div>
  );
}
